import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface OfficeProjectSearchParams {
  keyword?: string;
  officeId?: string;
  officeName?: string;
  officeAddress?: string;
  region?: string;
  officeType?: string;
  officeEmail?: string;
  managerName?: string;
  contactNumber?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getOfficeProjects = async (params: OfficeProjectSearchParams = {}) => {
  const response = await axiosInstance.get("/building/office-project/search_office_projects", {
    params : {
      limit: 1000000,
    },
  });
  return response.data;
};

export const getAllOffices = async () => {
  const response = await axiosInstance.get("/offices/search_offices",{
    params: {
      limit: 1000000,
    },
  });
  return response.data;
};

export interface OfficeLocationSearchParams {
  keyword?: string;
  officeId?: string;
  locationId?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getOfficeLocations = async (params: OfficeLocationSearchParams = {}) => {
  const response = await axiosInstance.get("/offices/search_offices", {
    params,
  });
  return response.data;
};


export const fetchOfficePhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/offices/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Office
export const createOfficeProject = async (data) => {
  const formData = {
    officeId: data.officeId,
    buildingValuation: data.buildingValuation,
    identifierMB: data.identifierMB,
  };

  const response = await axiosInstance.post(`/building/office-project/create_office_project`, formData);
  return response.data; // contains the office `id` or `code`
};

// Create Office Location
export const createOfficeLocation = async (data) => {
  
  const response = await axiosInstance.post(`/officeLocations/create_office_location`, data);
  return response.data; // contains the office `id` or `code`
};

// Step 2: Upload Photo by Office ID
export const uploadOfficePhoto = async (officeId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/offices/upload_photo/${officeId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Office
export const editOfficeProject = async (data) => {
  const formData = {
    officeId: data.officeId,
    buildingValuation: data.buildingValuation,
    identifierMB: data.identifierMB,
  };

  const response = await axiosInstance.put(`/building/office-project/update_office_project/${data.id}`, formData);
  return response.data; // contains the office `id` or `code`
};

export const deleteOfficeProject = async (officeId: string) => {
  const response = await axiosInstance.delete(`/building/office-project/delete_office_projects/${officeId}`);
  return response.data;
};
